import { Mapper } from '../../../mappers';
import { RelatedEntryRelationship } from '../../../models';
import { RelatedEntry, ValueAndDisplay } from '../models';

export class RelatedEntryMapper extends Mapper<
  RelatedEntry[],
  RelatedEntryRelationship[]
> {
  from(source: RelatedEntry[]): RelatedEntryRelationship[] {
    return source.map((item) => ({
      id: item.Key ?? '',
      from: item.FromKey ?? '',
      to: item.ToKey ?? '',
      type: (item.RelationType as ValueAndDisplay<string[]>).DisplayValue ?? '',
    }));
  }
}
